import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const apiBase = (): string => import.meta.env.VITE_API_BASE_URL || "";

/**
 * Slim top nav for the living survey. Lets people jump between adding their
 * input and asking the room. Intentionally quiet so it never competes with the
 * conversation.
 *
 * The Admin link only appears for a signed-in, allowlisted admin (checked via
 * /api/admin/whoami). Regular respondents never see it.
 */
export function SurveyNav({ current }: { current: "survey" | "ask" }) {
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let alive = true;
    fetch(`${apiBase()}/api/admin/whoami`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : { admin: false }))
      .then((d) => {
        if (alive) setIsAdmin(!!d.admin);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return (
    <nav className="flex items-center justify-between max-w-3xl w-full mx-auto py-1">
      <span className="text-[11px] uppercase tracking-[0.24em] text-ink-300">Nellis Auction</span>
      <div className="flex items-center gap-5 text-[11px] uppercase tracking-[0.16em]">
        <Tab to="/survey" active={current === "survey"}>
          Your Voice
        </Tab>
        <Tab to="/ask" active={current === "ask"}>
          Our Voices
        </Tab>
        {isAdmin && (
          <Tab to="/admin/survey" active={false}>
            Admin
          </Tab>
        )}
      </div>
    </nav>
  );
}

function Tab({ to, active, children }: { to: string; active: boolean; children: React.ReactNode }) {
  return (
    <Link
      to={to}
      className={[
        "inline-flex items-center min-h-[24px] py-1",
        active
          ? "text-ink-900 border-b border-ink-900"
          : "text-ink-500 hover:text-ink-900 transition-colors",
      ].join(" ")}
    >
      {children}
    </Link>
  );
}
